var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCarouselPrev = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "carousel-prev_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M0 0h15v15H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  clipPath: "url(#carousel-prev_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 101",
  d: "m1.448 7.495 6.56-6.56"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 102",
  d: "m1.448 7.495 6.56 6.56"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 39",
  d: "M13.235 7.668H1.494"
}))));

export default SvgCarouselPrev;